<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :unique-opened="true"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#3B3E47"
      text-color="#bfcbd9"
      active-text-color="#8ffff9"
    >
      <sidebar-item v-for="route in permission_routers" :key="(route.id || '') + route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
